import type { CSSProperties } from "react"

/** Feeds a child's position to CSS so stagger delays stay in the stylesheet. */
export function indexVar(index: number): CSSProperties {
  return { "--i": index } as CSSProperties
}

export function twoDigit(value: number): string {
  return String(value).padStart(2, "0")
}
